<template>
    <div>
        <Search />
        <iframe name="hiddenframe" hidden></iframe>
    </div>
</template>
<script>
import Search from "../../components/Search/Search.vue";

export default {
    components: {
        Search
    }
}
</script>